<template>
<div>
    <SearchBox ref="SearchBox">
        <el-form slot="form" style="margin-left: 5vw" :inline="true" ref="searchData" :model="searchParams"
                 label-width="200px" class="unitWidth" size="small">
            <el-form-item :label="$t('Account.deliveryCode')">
                <el-input :placeholder="$t('Account.system')" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Account.deliveryType')">
                <el-select v-model="searchParams.deliveryType" :placeholder="$t('User.select')">
                    <el-option label="领用" value="LG"></el-option>
                    <!--<el-option label="调拨" value="DB"></el-option>-->
                    <el-option label="报废" value="BF"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form slot="form" style="margin-left: 5vw" :inline="true" ref="searchData" :model="searchParams"
                 label-width="200px" class="unitWidth" size="small">
            <el-form-item :label="$t('Shift.factory')">
                <el-select v-model="searchParams.fcCode" :placeholder="$t('base.PleaseSelect')" :disabled="ischeck"
                           :clearable="isclear" filterable
                           @change="fcChange">
                    <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName"
                               :value="factory.fcCode"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('Account.storeName')">
                <el-select v-model="searchParams.strCode" :placeholder="$t('User.select')" clearable filterable
                           @change="sparePartPositionList">
                    <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName"
                               :value="house.strCode"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form slot="form" style="margin-left: 5vw" :inline="true" ref="searchData" :model="searchParams"
                 label-width="200px" class="unitWidth" size="small">
            <el-form-item :label="$t('Account.useType')">
                <el-select v-model="searchParams.useType" :placeholder="$t('User.select')" clearable @change="switchType">
                    <el-option label="安灯" value="andon"></el-option>
                    <el-option label="保养" value="PM"></el-option>
                    <el-option label="其它" value="OT"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="searchParams.useName" v-if="searchParams.useType == 'andon'">
                <el-select v-model="searchParams.useCode" :placeholder="$t('base.PleaseSelect')" clearablea filterable
                           @change="selectUseUser">
                    <el-option v-for="andon in andonList" :key="andon.andonId" :label="andon.andonCode"
                               :value="andon.andonCode"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="searchParams.useName" v-if="searchParams.useType == 'PM'">
                <el-select v-model="searchParams.useCode" :placeholder="$t('base.PleaseSelect')" clearablea filterable
                           @change="selectUseUser">
                    <el-option v-for="main in maintainList" :key="main.pmoId" :label="main.pmoNo"
                               :value="main.pmoNo"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="searchParams.useName" v-if="searchParams.useType == 'OT'">
                <el-select v-model="searchParams.useUser" :placeholder="$t('base.PleaseSelect')" clearablea filterable>
                    <el-option v-for="user in userList" :key="user.userId" :label="user.userName"
                               :value="user.userAccount"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form slot="form" style="margin-left: 5vw; display: flex" :inline="true" ref="searchData"
                 :model="searchParams" label-width="200px" class="unitWidth" size="small">
            <el-form-item :label="$t('Account.remark')">
                <el-input class="textarea" rows="3" type="textarea" :placeholder="$t('base.PleaseEnter')"
                          v-model="searchParams.deliveryDesc"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 25vw; display: flex; margin-top: 2vw">
                <el-button size="small" type="primary" @click="addPartDeliveryOrder">{{$t('base.save')}}</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="200px"
                 class="unitWidth" size="small">
            <el-form-item label="制单人">
                <span>{{userName}}</span>
            </el-form-item>
            <el-form-item label="总价">
                <span>{{totalPrice}}元</span>
            </el-form-item>
        </el-form> -->
        <el-form style="display: flex; margin-left: 15vw" slot="form" :inline="true" ref="searchData"
                 :model="searchParams" label-width="200px" class="unitWidth" size="small">
            <el-form-item :label="$t('Account.preparedBy')">
                <span>{{ userName }}</span>
            </el-form-item>
            <el-form-item style="margin-left: 2vw" :label="$t('Account.totalPrice')">
                <span style="color: red">{{ totalPrice }}{{$t('Account.RMB')}}</span>
            </el-form-item>
        </el-form>
    </SearchBox>
    <LabelContent ref="LabelContent">
        <div slot="btns">
            <el-button size="small" type="success" @click="addPartDelOrder()">{{$t('base.add')}}</el-button>
        </div>
    </LabelContent>
    <div class="tableBox">
        <el-table stripe ref="multipleTable" :data="tableData" class="center" border>
            <el-table-column prop="spCode" :label="$t('Account.spareCode')"/>
            <el-table-column prop="spName" :label="$t('Account.spareName')"/>
            <el-table-column prop="spModel" :label="$t('Account.spareModel')"/>
            <el-table-column prop="unit" :label="$t('Account.unit')"/>
            <el-table-column prop="sppName" :label="$t('Account.locatorName')"/>
            <el-table-column prop="batchNo" :label="$t('Account.batchNo')"/>
            <el-table-column prop="stockAmount" :label="$t('Account.currentStock')"/>
            <el-table-column prop="amount" :label="$t('Account.deliveryNum')" width="250">
                <template slot-scope="scope">
                    <el-input-number v-model.trim="scope.row.amount" :min="1"
                                     @change="priceCalculation(scope.row, scope.$index)"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column prop="spPrice" :label="$t('Account.price')"/>
            <el-table-column prop="totalPrice" :label="$t('Account.totalPrice')"/>
            <el-table-column :label="$t('base.operation')" width="100">
                <template slot-scope="scope">
                    <i class="delBtn iconfont u-shanchu" @click="deletePartDelOrder(scope)"/>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog title="出库备件信息" width="40vw" :visible.sync="updateShow" style="text-align: left">
        <el-form :model="sparePartInfo" :rules="partInfo" ref="partInfo" label-width="100px" class="demo-roleForm">
            <el-form-item label="备件编码" prop="spCode">
                <!--                    <el-input v-model="sparePartInfo.spCode"></el-input>-->
                <el-select
                    v-model="sparePartInfo.spCode"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="queryPartInfoBySpCode"
                >
                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备件型号">
                <el-input v-model="sparePartInfo.spModel" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="备件名称">
                <el-input v-model="sparePartInfo.spName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="单位">
                <el-input v-model="sparePartInfo.unit" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="选择库位" prop="locatorCode">
                <el-select v-model="sparePartInfo.locatorCode" placeholder="请选择" filterable
                           @change="querySpareCode">
                    <el-option v-for="partPosition in partPositionList" :key="partPosition.sppId"
                               :label="partPosition.sppName" :value="partPosition.sppCode"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="批次号">
                <el-input v-model="sparePartInfo.batchNo" @change="querySpareCode"></el-input>
            </el-form-item>
            <el-form-item label="当前库存">
                <el-input v-model="sparePartInfo.stockAmount" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="出库数量" prop="amount">
                <el-input-number v-model.trim="sparePartInfo.amount" :min="1" placeholder="请输入入库数量(必填)"
                                 @change="judgeTQua"></el-input-number>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="updateShow = false">取 消</el-button>
            <el-button type="primary" @click="updatePartDelivery('partInfo')">确定</el-button>
        </span>
    </el-dialog>

    <el-dialog :title="$t('Account.deliveryInfo')" width="80vw" :visible.sync="updateTableShow" style="text-align: left">
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" :model="sparePartInfo" :rules="partInfo" ref="partInfo"
                     label-width="100px"
                     class="demo-roleForm">
                <el-form-item :label="$t('Account.spareCode')">
                    <el-input v-model="sparePartInfo.spCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareName')">
                    <el-input v-model="sparePartInfo.spName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareModel')">
                    <el-input v-model="sparePartInfo.spModel"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.batchNo')">
                    <el-input v-model="sparePartInfo.batchNo"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="searchTable()">{{$t('base.search')}}</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableSelectData" tooltip-effect="dark" class="center" border>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="spName" :label="$t('Account.spareName')"/>
                <el-table-column prop="spCode" :label="$t('Account.spareCode')" width="150"/>
                <el-table-column prop="spModel" :label="$t('Account.spareModel')"/>
                <el-table-column prop="unit" :label="$t('Account.unit')"/>
                <el-table-column prop="batchNo" :label="$t('Account.batchNo')" width="150"/>
                <el-table-column prop="sppName" :label="$t('Account.locatorName')" width="150"/>
                <el-table-column prop="stockAmount" :label="$t('Account.currentStock')"/>
                <el-table-column prop="amount" :label="$t('Account.deliveryNum')" width="210">
                    <template slot-scope="scope" align="center">
                        <el-input-number v-model.trim="scope.row.amount" :min="0"
                                         :placeholder="$t('User.input')"
                                         @change="judgeTQuaSelect(scope.$index)"></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="updateTableShow = false">{{$t('base.cancel')}}</el-button>
            <el-button type="primary" @click="updateSelectPartPurchase()">{{$t('base.confirm')}}</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'addPartDeliveryOrder',
    data() {
        return {
            saveShow: false,
            searchParams: {
                fcCode: '',
                strCode: '',
                deliveryType: '',
                deliveryTime: '',
                deliveryDesc: '',
                useType: '',
                useCode: '',
                useUser: '',
                useName: '',
                useShow: false
            },
            tableData: [],
            andonList: [],
            houseList: [],
            partPositionList: [],
            userList: [],
            maintainList: [],
            userName: '',
            updateShow: false,
            loading: false,
            sparePartInfo: {
                spCode: '',
                spModel: '',
                spName: '',
                unit: '',
                locatorCode: '',
                sppName: '',
                amount: '',
                spiId: '',
                spPrice: '',
                totalPrice: '',
                stockAmount: '',
                batchNo: ''
            },
            partInfo: {
                spCode: [
                    {
                        required: true,
                        message: this.$t('base.PleaseEnter'),
                        trigger: 'blur'
                    }
                ],
                locatorCode: [
                    {
                        required: true,
                        message: this.$t('base.PleaseSelect'),
                        trigger: 'blur'
                    }
                ],
                amount: [
                    {
                        required: true,
                        message: this.$t('base.PleaseEnter'),
                        trigger: 'blur'
                    }
                ]
            },
            partInfoList: [],
            options: [],
            value: [],
            list: [],
            factoryList: [],
            userInfo: {},
            role: {},
            ischeck: true,
            isclear: false,
            updateTableShow: false,
            tableSelectData: [],
            selectionList: []
        }
    },
    computed: {
        totalPrice: function() {
            var totalPrice = 0
            for (let i = 0; i < this.tableData.length; i++) {
                totalPrice += this.tableData[i].spPrice * this.tableData[i].amount
            }
            return totalPrice
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.userName = this.$store.state.userInfo.userName
            this.userInfo = this.$store.state.userInfo
            var role = this.userInfo.roles
            for (var i = 0; i < role.length; i++) {
                //所有工厂数据
                if (role[i].factoryId == 0) {
                    this.ischeck = false
                    this.role = role[i]
                    this.isclear = true
                    break
                } else {
                    if (this.userInfo.factoryId == role[i].factoryId) {
                        this.role = role[i]
                    }
                }
            }
            this.getAllFactory()
        },
        addPartDelOrder() {
            if (this.searchParams.strCode == undefined || this.searchParams.strCode == '') {
                this.$message.error(this.$t('Account.selectCk'))
                return
            }
            this.$refs.multipleTable.clearSelection()
            this.tableSelectData = []
            // this.updateShow = true
            this.updateTableShow = true
        },
        updatePartDelivery(partInfo) {
            this.$refs[partInfo].validate((valid) => {
                if (valid) {
                    if (this.sparePartInfo.amount == 0) {
                        this.$message.info(this.$t('msg.zero'))
                        return
                    }
                    if (this.sparePartInfo.stockAmount == undefined || this.sparePartInfo.stockAmount == '') {
                        this.$message.info(this.$t('msg.empty'))
                        return
                    }
                    for (let i = 0; i < this.tableData.length; i++) {
                        if (this.tableData[i].sppCode == this.sparePartInfo.locatorCode &&
                            this.tableData[i].spCode == this.sparePartInfo.spCode &&
                            this.tableData[i].batchNo == this.sparePartInfo.batchNo) {
                            if ((this.sparePartInfo.amount + this.tableData[i].amount) > this.sparePartInfo.stockAmount) {
                                this.$message.error(this.$t('msg.greater'))
                                return
                            }
                            this.tableData[i].amount = (this.sparePartInfo.amount + this.tableData[i].amount)
                            this.tableData[i].totalPrice = (this.tableData[i].amount * this.sparePartInfo.spPrice)
                            this.updateShow = false
                            return
                        }
                    }
                    var array = {
                        sppCode: this.sparePartInfo.locatorCode,
                        spCode: this.sparePartInfo.spCode,
                        spModel: this.sparePartInfo.spModel,
                        spName: this.sparePartInfo.spName,
                        unit: this.sparePartInfo.unit,
                        locatorCode: this.sparePartInfo.locatorCode,
                        amount: this.sparePartInfo.amount,
                        spiId: this.sparePartInfo.spiId,
                        spPrice: this.sparePartInfo.spPrice,
                        totalPrice: this.sparePartInfo.totalPrice = (this.sparePartInfo.amount * this.sparePartInfo.spPrice),
                        sppName: this.sparePartInfo.sppName,
                        stockAmount: this.sparePartInfo.stockAmount,
                        batchNo: this.sparePartInfo.batchNo
                    }
                    this.tableData.push(array)
                    this.updateShow = false
                } else {
                    return false
                }
            })
        },
        updateSelectPartPurchase() {
            this.selectionList = this.$refs.multipleTable.selection
            if (this.selectionList.length == 0) {
                this.$message.error(this.$t('msg.spare'))
                return
            }
            for (let i = 0; i < this.selectionList.length; i++) {
                if (this.selectionList[i].amount == 0) {
                    this.$message.error(this.$t('msg.zero'))
                    return
                }
                if (this.selectionList[i].amount == undefined || this.selectionList[i].amount == '') {
                    this.$message.error(this.$t('Account.deliveryNum'))
                    return
                }
            }
            if (this.tableData.length != 0) {
                for (let a1 = 0; a1 < this.tableData.length; a1++) {
                    for (let a2 = 0; a2 < this.selectionList.length; a2++) {
                        if (this.tableData[a1].sppCode == this.selectionList[a2].sppCode &&
                            this.tableData[a1].spCode == this.selectionList[a2].spCode &&
                            this.tableData[a1].batchNo == this.selectionList[a2].batchNo) {
                            if ((this.selectionList[a2].amount + this.tableData[a1].amount) > this.selectionList[a2].stockAmount) {
                                this.$message.error(this.$t('msg.greater'))
                                return
                            }
                            this.tableData[a1].amount = (this.selectionList[a2].amount + this.tableData[a1].amount)
                            this.tableData[a1].totalPrice = (this.tableData[a1].amount * this.selectionList[a2].spPrice)
                            this.selectionList.splice(a2, 1)
                        }
                    }
                }
                if (this.selectionList.length != 0) {
                    for (let a3 = 0; a3 < this.selectionList.length; a3++) {
                        let array = {
                            sppCode: this.selectionList[a3].sppCode,
                            spCode: this.selectionList[a3].spCode,
                            spModel: this.selectionList[a3].spModel,
                            spName: this.selectionList[a3].spName,
                            unit: this.selectionList[a3].unit,
                            amount: this.selectionList[a3].amount,
                            spiId: this.selectionList[a3].spiId,
                            spPrice: this.selectionList[a3].spPrice,
                            totalPrice: this.selectionList[a3].totalPrice = (this.selectionList[a3].amount * this.selectionList[a3].spPrice),
                            sppName: this.selectionList[a3].sppName,
                            stockAmount: this.selectionList[a3].stockAmount,
                            batchNo: this.selectionList[a3].batchNo
                        }
                        this.tableData.push(array)
                    }
                }
            } else {
                for (let a4 = 0; a4 < this.selectionList.length; a4++) {
                    let array = {
                        sppCode: this.selectionList[a4].sppCode,
                        spCode: this.selectionList[a4].spCode,
                        spModel: this.selectionList[a4].spModel,
                        spName: this.selectionList[a4].spName,
                        unit: this.selectionList[a4].unit,
                        amount: this.selectionList[a4].amount,
                        spiId: this.selectionList[a4].spiId,
                        spPrice: this.selectionList[a4].spPrice,
                        totalPrice: this.selectionList[a4].totalPrice = (this.selectionList[a4].amount * this.selectionList[a4].spPrice),
                        sppName: this.selectionList[a4].sppName,
                        stockAmount: this.selectionList[a4].stockAmount,
                        batchNo: this.selectionList[a4].batchNo
                    }
                    this.tableData.push(array)
                }
            }
            this.updateTableShow = false
        },
        deletePartDelOrder(row) {
            this.tableData.splice(row.$index, 1)
        },
        priceCalculation(row, index) {
            if (row.amount > row.stockAmount) {
                this.$nextTick(() => {
                    this.tableData[index].amount = 0
                    this.tableData[index].amount = this.tableData[index].stockAmount
                })
                this.$message.error(this.$t('msg.greater'))
            }
            this.tableData[index].totalPrice = row.amount * row.spPrice
        },
        judgeTQua() {
            if (this.sparePartInfo.amount > this.sparePartInfo.stockAmount) {
                this.$nextTick(() => {
                    this.sparePartInfo.amount = 0
                    this.sparePartInfo.amount = this.sparePartInfo.stockAmount
                })
                this.$message.error(this.$t('msg.greater'))
            }
        },
        judgeTQuaSelect(index) {
            if (this.tableSelectData[index].amount > this.tableSelectData[index].stockAmount) {
                this.$nextTick(() => {
                    this.tableSelectData[index].amount = 0
                    this.tableSelectData[index].amount = this.tableSelectData[index].stockAmount
                })
                this.$message.error(this.$t('msg.greater'))
            }
        },
        switchType() {
            this.searchParams.useCode = ''
            if (this.searchParams.useType == 'andon') {
                this.andonOrderList()
                this.searchParams.useName = '安灯编码'
                this.searchParams.useShow = true
            } else if (this.searchParams.useType == 'OT') {
                this.searchParams.useName = '领用人'
                this.searchParams.useShow = false
                this.searchParams.useUser = ''
                this.andonList = []
                this.maintainList = []
            } else if (this.searchParams.useType == 'PM') {
                this.planMaintainOrderList()
                this.searchParams.useName = '计划保养编码'
                this.searchParams.useShow = true
            } else if (this.searchParams.useType == undefined || this.searchParams.useType == '') {
                this.searchParams.useName = ''
                this.searchParams.useShow = false
                this.andonList = []
                this.maintainList = []
            }
        },
        selectUseUser() {
            if (this.searchParams.useType == 'andon') {
                for (let i = 0; i < this.andonList.length; i++) {
                    if (this.andonList[i].andonCode == this.searchParams.useCode) {
                        this.searchParams.useUser = this.andonList[i].andonRespUser
                    }
                }
            }
            if (this.searchParams.useType == 'PM') {
                for (let i = 0; i < this.maintainList.length; i++) {
                    if (this.maintainList[i].pmoNo == this.searchParams.useCode) {
                        this.searchParams.useUser = this.maintainList[i].pmoActionUserNo
                    }
                }
            }
        },
        addPartDeliveryOrder() {
            if (this.searchParams.deliveryType == undefined || this.searchParams.deliveryType == '') {
                this.$message.info(this.$t('Account.deliveryType'))
                return
            }
            if (this.searchParams.fcCode == undefined || this.searchParams.fcCode == '') {
                this.$message.info(this.$t('mechanism.selectFc'))
                return
            }
            if (this.searchParams.strCode == undefined || this.searchParams.strCode == '') {
                this.$message.info(this.$t('Account.selectCk'))
                return
            }
            if (this.tableData.length == 0) {
                this.$message.info(this.$t('msg.delivery'))
                return
            }
            /*if (this.searchParams.deliveryDesc == undefined || this.searchParams.deliveryDesc == '') {
                this.$message.info('请输入出库备注！')
                return
            }*/
            if (this.searchParams.useType == undefined || this.searchParams.useType == '') {
                this.$message.info(this.$t('Account.useType'))
                return
            }
            if (this.searchParams.useType == 'andon') {
                if (this.searchParams.useCode == undefined || this.searchParams.useCode == '') {
                    this.$message.info(this.$t('Account.lampCode'))
                    return
                }
            }
            if (this.searchParams.useType == 'PM') {
                if (this.searchParams.useCode == undefined || this.searchParams.useCode == '') {
                    this.$message.info(this.$t('Account.planMaintenanceCode'))
                    return
                }
            }
            if (this.searchParams.useType == 'OT') {
                if (this.searchParams.useUser == undefined || this.searchParams.useUser == '') {
                    this.$message.info(this.$t('Account.recipient'))
                    return
                }
            }
            let queryParams = {
                fcCode: this.searchParams.fcCode,
                strCode: this.searchParams.strCode,
                deliveryType: this.searchParams.deliveryType,
                deliveryTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                deliveryDesc: this.searchParams.deliveryDesc,
                useType: this.searchParams.useType,
                useCode: this.searchParams.useCode,
                useUser: this.searchParams.useUser,
                itemForm: this.tableData
            }
            let options = {
                method: 'POST',
                url: this.$api.addPartDeliveryOrderLogs,
                data: queryParams
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.$message.success(this.$t('base.SuccessfullyAdded'))
                    this.$router.push({
                        name: 'sparePartDeliveryOrder'
                    })
                } else {
                    this.$message.error(response.message)
                }
            })
        },
        querySpareCode() {
            for (let i = 0; i < this.partPositionList.length; i++) {
                if (this.partPositionList[i].sppCode == this.sparePartInfo.locatorCode) {
                    this.sparePartInfo.sppName = this.partPositionList[i].sppName
                }
            }
            let params = {
                fcCode: this.searchParams.fcCode,
                sppCode: this.sparePartInfo.locatorCode,
                spCode: this.sparePartInfo.spCode,
                batchNo: this.sparePartInfo.batchNo
            }
            let options = {
                method: 'get',
                url: this.$api.queryAmount,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    if (response.data != undefined && response.data != '') {
                        this.sparePartInfo.stockAmount = response.data.amount
                    } else {
                        this.sparePartInfo.stockAmount = ''
                        this.$message.error(this.sparePartInfo.spCode == undefined || this.sparePartInfo.spCode == '' ?
                            this.$t('Account.spareCode') : this.$t('msg.empty'))
                    }
                }
            })
        },
        querySelectSpareCode(index) {
            for (let i = 0; i < this.partPositionList.length; i++) {
                if (this.partPositionList[i].sppCode == this.tableSelectData[index].sppCode) {
                    this.tableSelectData[index].sppName = this.partPositionList[i].sppName
                }
            }
            let params = {
                fcCode: this.searchParams.fcCode,
                sppCode: this.tableSelectData[index].sppCode,
                spCode: this.tableSelectData[index].spCode,
                batchNo: this.tableSelectData[index].batchNo
            }
            let options = {
                method: 'get',
                url: this.$api.queryAmount,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    if (response.data != undefined && response.data != '') {
                        this.tableSelectData[index].stockAmount = response.data.amount
                    } else {
                        this.tableSelectData[index].stockAmount = ''
                        this.$message.error(this.tableSelectData[index].spCode == undefined || this.tableSelectData[index].spCode == '' ?
                            this.$t('Account.spareCode') : this.$t('msg.empty'))
                    }
                    this.tableSelectData.splice(1, 0)
                }
            })
        },
        queryPartInfoBySpCode() {
            let params = {
                spCode: this.sparePartInfo.spCode,
                fcCode: this.searchParams.fcCode
            }
            let options = {
                method: 'get',
                url: this.$api.queryByPartInfoSpCode,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    if (response.data != undefined && response.data != '') {
                        this.sparePartInfo.spName = response.data.spName
                        this.sparePartInfo.spBrand = response.data.spBrand
                        this.sparePartInfo.spModel = response.data.spModel
                        this.sparePartInfo.unit = response.data.unit
                        this.sparePartInfo.spiId = response.data.spiId
                        this.sparePartInfo.spPrice = response.data.spPrice
                    } else {
                        this.sparePartInfo.spName = ''
                        this.sparePartInfo.spBrand = ''
                        this.sparePartInfo.spModel = ''
                        this.sparePartInfo.unit = ''
                    }
                    this.sparePartInfo.locatorCode != undefined && this.sparePartInfo.locatorCode != '' ?
                        this.querySpareCode() : ''
                }
            })
        },
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true
                setTimeout(() => {
                    this.loading = false
                    this.options = this.list.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1
                    })
                }, 200)
            } else {
                this.options = []
            }
        },
        remoteList() {
            if (this.partInfoList != undefined && this.partInfoList != '') {
                this.list = this.partInfoList.map(item => {
                    return { value: item.spCode, label: item.spCode + '(' + item.spName + ')' }
                })
            } else {
                this.partInfoList = []
            }
        },
        fcChange() {
            if (this.searchParams.fcCode == undefined || this.searchParams.fcCode == '') {
                this.searchParams.strCode = ''
                this.searchParams.useType = ''
                this.houseList = []
                this.partInfoList = []
                this.userList = []
                return
            }
            this.searchParams.strCode = ''
            this.searchParams.useType = ''
            this.searchParams.useCode = ''
            this.searchParams.useUser = ''
            this.houseList = []
            this.partInfoList = []
            this.userList = []
            this.partStoreHouseList()
            this.sparePartInfoList()
            this.getUserList()
            this.andonOrderList()
        },
        getAllFactory() {
            let options = {
                method: 'get',
                url: this.$api.getAllFactory
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.factoryList = []
                    if (this.ischeck) {
                        var aa = response.data
                        var role = JSON.parse(sessionStorage.getItem('userInfo')).roles
                        for (let i = 0; i < aa.length; i++) {
                            for (let j = 0; j < role.length; j++) {
                                if (aa[i].factoryId == role[j].factoryId) {
                                    this.factoryList.push(aa[i])
                                }
                            }
                        }
                        this.searchParams.fcCode = this.role.fcCode
                    } else {
                        this.factoryList = response.data
                    }
                    this.partStoreHouseList()
                    this.sparePartInfoList()
                    this.getUserList()
                }
            })
        },
        sparePartInfoList() {
            let params = {}
            if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                params['fcCode'] = this.searchParams.fcCode
            } else {
                return
            }
            let options = {
                method: 'get',
                url: this.$api.sparePartInfoList,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.partInfoList = response.data
                    this.remoteList()
                }
            })
        },
        partStoreHouseList() {
            let params = {}
            if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                params['fcCode'] = this.searchParams.fcCode
            } else {
                return
            }
            let options = {
                method: 'get',
                url: this.$api.partStoreHouseList,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.houseList = response.data
                }
            })
        },
        andonOrderList() {
            let params = {
                switchState: 'Delivery'
            }
            if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                params['fcCode'] = this.searchParams.fcCode
            } else {
                return
            }
            let options = {
                method: 'get',
                url: this.$api.andonOrderList,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.andonList = response.data
                }
            })
        },
        planMaintainOrderList() {
            let params = {}
            if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                params['fcCode'] = this.searchParams.fcCode
            } else {
                return
            }
            let options = {
                method: 'get',
                url: this.$api.planMaintainOrderList,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.maintainList = response.data
                }
            })
        },
        sparePartPositionList() {
            let queryParams = {}
            if (this.searchParams.strCode != undefined && this.searchParams.strCode != '') {
                queryParams['strCode'] = this.searchParams.strCode
            } else {
                return
            }
            let options = {
                method: 'get',
                url: this.$api.sparePartPositionList,
                params: queryParams
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.partPositionList = response.data
                }
            })
        },
        getUserList() {
            let params = {}
            if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                params['fcCode'] = this.searchParams.fcCode
            } else {
                return
            }
            let options = {
                method: 'get',
                url: this.$api.userList,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.userList = response.data
                }
            })
        },
        searchTable() {
            let queryParams = {}
            this.tableSelectData = []
            if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                queryParams['fcCode'] = this.searchParams.fcCode
            } else {
                return
            }
            if ((this.sparePartInfo.spCode == undefined || this.sparePartInfo.spCode == '') &&
                (this.sparePartInfo.spName == undefined || this.sparePartInfo.spName == '') &&
                (this.sparePartInfo.spModel == undefined || this.sparePartInfo.spModel == '') &&
                (this.sparePartInfo.batchNo == undefined || this.sparePartInfo.batchNo == '')) {
                this.$message.error(this.$t('base.PleaseEnter'))
                return
            }
            if (this.sparePartInfo.spCode != undefined && this.sparePartInfo.spCode != '') {
                queryParams['spCode'] = this.sparePartInfo.spCode
            }
            if (this.sparePartInfo.spName != undefined && this.sparePartInfo.spName != '') {
                queryParams['spName'] = this.sparePartInfo.spName
            }
            if (this.sparePartInfo.spModel != undefined && this.sparePartInfo.spModel != '') {
                queryParams['spModel'] = this.sparePartInfo.spModel
            }
            if (this.sparePartInfo.batchNo != undefined && this.sparePartInfo.batchNo != '') {
                queryParams['batchNo'] = this.sparePartInfo.batchNo
            }
            if (this.searchParams.strCode != undefined && this.searchParams.strCode != '') {
                queryParams['strCode'] = this.searchParams.strCode
            }
            let options = {
                method: 'get',
                url: this.$api.sparePartLibrary,
                params: queryParams
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    // this.tableSelectData = response.data
                    if (response.data != undefined && response.data != '') {
                        let tableSelectData = response.data
                        for (let i = 0; i < tableSelectData.length; i++) {
                            let array = {
                                sptId: '',
                                sppCode: '',
                                sppName: '',
                                amount: '',
                                batchNo: '',
                                spiId: '',
                                spName: '',
                                spCode: '',
                                spBrand: '',
                                spModel: '',
                                unit: '',
                                spPrice: '',
                                stockAmount: ''
                            }
                            array.sptId = tableSelectData[i].sptId
                            array.sppCode = tableSelectData[i].sppCode
                            array.sppName = tableSelectData[i].sppName
                            array.stockAmount = tableSelectData[i].amount
                            array.amount = 0
                            array.batchNo = tableSelectData[i].batchNo
                            array.spiId = tableSelectData[i].spiId
                            array.spName = tableSelectData[i].spName
                            array.spCode = tableSelectData[i].spCode
                            array.spBrand = tableSelectData[i].spBrand
                            array.sptId = tableSelectData[i].sptId
                            array.spModel = tableSelectData[i].spModel
                            array.unit = tableSelectData[i].unit
                            array.spPrice = tableSelectData[i].spPrice
                            this.tableSelectData.push(array)
                        }
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
::v-deep .el-textarea__inner {
    width: 37vw !important;
}
</style>
